import { render, staticRenderFns } from "./serviceIframe.vue?vue&type=template&id=7ee3e423&scoped=true"
import script from "./serviceIframe.vue?vue&type=script&lang=js"
export * from "./serviceIframe.vue?vue&type=script&lang=js"
import style0 from "./serviceIframe.vue?vue&type=style&index=0&id=7ee3e423&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee3e423",
  null
  
)

export default component.exports